import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { Avatar } from '@mui/material';
import Grid from '@mui/material/Grid';

export default function DialogConfirm({onConfirm, onCancel, open, message, title = "Confirmar"}) {

  const theme = useTheme();
  // Abaixo de `sm` o modal vira bottom sheet (tema); tela cheia só em sm..md.
  const fullScreen = useMediaQuery(theme.breakpoints.between('sm', 'md'));

  const handleConfirm = () => {
    onConfirm();
  };

  const handleClose = () => {
    if (onCancel) {
      onCancel();
    }
  };

  return (
    <div>
      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle id="responsive-dialog-title">
          <Grid container sx={{justifyContent: "center"}} >
            <Grid item >
              <Avatar >
                <QuestionMarkIcon/>
              </Avatar>
            </Grid>
          </Grid>
          <div style={{textAlign: "center", marginTop: "10px"}}>
            {title}
          </div>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {message}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Cancelar
          </Button>
          <Button onClick={handleConfirm} autoFocus>
            Confirmar
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}